import React, { useEffect, useState } from 'react'
import Grid from '@mui/joy/Grid'
import './Stamp.css'
import Stamp from './Stamp'
import { useParams } from 'react-router-dom'
import { StampResponse, useGetMyStampsQuery } from '../services/stamps'
import { useGetStoreByIdQuery } from '../services/stores' // Import your CSS file for styles

type StampsProps = {
  lastStamp: number
  stampImagePath: string
  isLoading: boolean
  textColor: string
  font: string
  setEarned: (earned: boolean) => void
}

const Stamps = (props: StampsProps) => {
  const { id: storeId } = useParams() as { id: string }

  const [stateMyStamps, setStateMyStamps] = useState<StampResponse[]>([])

  const [limit, setLimit] = useState<number>(21)

  const { data: store } = useGetStoreByIdQuery(storeId)
  const { data: myStamps } = useGetMyStampsQuery(
    { storeId: storeId, limit: limit },
    {
      skip: limit === 21,
    },
  )

  useEffect(() => {
    if (store) {
      setLimit(store.numberOfStamps)
    }
  }, [store])

  useEffect(() => {
    console.log("stateMyStamps.length")
    console.log(stateMyStamps.length)


    const lastShownRewardId = localStorage.getItem("lastShownRewardId")

    if (stateMyStamps.length >= limit) {
      if (lastShownRewardId !== null && !stateMyStamps?.find(s => s.rewardId === lastShownRewardId)) {
        props.setEarned(true)

        setTimeout(() => {
          setStateMyStamps([])
        }, 5000)

        localStorage.setItem("lastShownRewardId", stateMyStamps[0].rewardId)
      }
    }
  }, [stateMyStamps])

  useEffect(() => {
    if (myStamps) {
      console.log("myStamps")
      console.log(myStamps)
      const firstNonNullIndex = myStamps.findIndex(
        (stamp) => stamp.rewardId !== null,
      )

      const result =
        firstNonNullIndex !== -1
          ? myStamps.slice(0, firstNonNullIndex + 1)
          : myStamps.slice()

      console.log("result", result)

      if (result.length > 0) {
        setStateMyStamps(result)
      }
    }
  }, [myStamps])

  function formatDate(timestamp: string): string {
    const date = new Date(timestamp)
    const month = (date.getMonth() + 1).toString().padStart(2, '0') // Ensure two-digit month
    const day = date.getDate().toString().padStart(2, '0') // Ensure two-digit day

    return `${month}/${day}`
  }

  return (
    <Grid container xs={12} spacing={2} sx={{ textAlign: 'center' }}>
      {[...Array(store?.numberOfStamps)].map((_, index) => (
        <Stamp
          key={index}
          gridKey={index}
          collected={stateMyStamps.length >= index + 1}
          index={index}
          stampImagePath={props.stampImagePath}
          isLoading={props.isLoading}
          textColor={props.textColor}
          font={props.font}
          date={formatDate(stateMyStamps[index]?.stampDate)}
        />
      ))}
    </Grid>
  )
}

export default Stamps
